import React from 'react';
import { Grid, Typography } from '@mui/material';
import India from '../../assets/Icons/India';
import Confirmed from '../../assets/Icons/Confirmed';
import loginFooterStyles from './LoginFooter.styles';
import { useTranslation } from '../../hooks/useTranslation';
// mode: 'banner' = only 20Cr+ row, 'secure' = only Secure & Quick row, default = both
const LoginFooter = ({ mode } = {}) => {
	const { t } = useTranslation();
	const showBanner = !mode || mode === 'banner';
	const showSecure = !mode || mode === 'secure';
	return (
		<Grid
			container
			flexDirection={'column'}
			sx={{
				width: '100%',
				left: '0',
				bottom: '60px',
				borderRadius: '8px',
				overflow: 'hidden',
			}}
		>
			{showBanner && !global.disableTrustFooter && <Grid item>
				<Grid
					container
					sx={{ ...loginFooterStyles.gridContainer1, textAlign: 'left' }}
				>
					<Grid item sx={{ lineHeight: '0.5rem', ...loginFooterStyles.icon }}>
						<India />
					</Grid>

					<Grid item xs>
						<Typography>{t('login.footer.usedByMillions')}</Typography>
					</Grid>
				</Grid>
			</Grid>
            }

			{showSecure && <Grid item>
				<Grid
					container
					sx={{ ...loginFooterStyles.gridContainer2, textAlign: 'left' }}
				>
					<Grid item sx={{ lineHeight: '0.5rem', ...loginFooterStyles.icon }}>
						<Confirmed />
					</Grid>

					<Grid item xs>
						<Typography>
							{t('login.footer.secureQuickSharing')}
						</Typography>
					</Grid>
				</Grid>
			</Grid>}
		</Grid>
	);
};

export default LoginFooter;
